<template>
    <div class="page">
        <div class="page-top"></div>
        <div class="chooseTitle" ref="chooseTitle">
            <p class="index-common_title tc">
                众多的选择
            </p>
            <p class="index-common_subtitle tc">
               保证你业务的多样性和无限的可能性
            </p>
        </div>
        <div class="chooseList">
             <ul>
                <li class="chooseList_item icon_time">
                    <span>
                        <div class="item_title">
                            <b class="">定时切换时长</b>
                            <p class="">支持任意时长定时切换，多久时长切换IP都由您决定，任意时长可根据个人情况进行设定，符合用户操作，更加人性化</p>
                        </div>
                    </span>
                    <span class="icon_time_normal"></span>
                </li>
                <li class="chooseList_item icon_networkspeed">
                    <span class="icon_networkspeed_normal"></span>
                    <span>
                         <div class="item_title">
                            <b class="">网速保证</b>
                            <p class="">各节点百兆宽带独享，行业一流团队提供便捷，稳定和安全的技术服务，全平台最快捷的最全面的IP代理，你无需过多复杂操作就可极速上网畅快体验</p>
                        </div>
                    </span>
                </li>
                <li class="chooseList_item icon_safety">
                    <span>
                         <div class="item_title">
                            <b class="">匿名防查</b>
                            <p class="">跳转代理有高匿名IP且网络稳定，全方面保护您的隐私，网络防追踪，是您工作与上网需求的不二之选</p>
                        </div>
                    </span>
                    <span class="icon_safety_normal"></span>
                </li>
                <li class="chooseList_item icon_IP">
                    <span class="icon_IP_normal"></span>
                    <span>
                         <div class="item_title">
                            <b class="">海量IP，IP数量100万+</b>
                            <p class="">每个城市节点每天可用IP超过100万个，无论您每天使用少量IP，还是短期使用大量IP，都可满足您的业务需求</p>
                        </div>
                    </span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: "choose",
    props: {
        choose_animation: Boolean
    },
     methods: {
        getCls (element) {
            return element.getAttribute('class')
        },
        setCls (element,cls) {
            return element.setAttribute('class',cls)
        },
        addCls (element,cls) {
            var baseCls = this.getCls(element)
            if(baseCls.indexOf(cls) === -1){
                this.setCls(element,`${baseCls} ${cls}`)
            }
        },
        deleteCls (element,cls) {
            var baseCls = this.getCls(element)
            if(baseCls.indexOf(cls) !== -1){
                var splitCls = baseCls.split(cls).join(" ")
                this.setCls(element,splitCls)
            }
        }
    },
    watch: {
        choose_animation () {
            var items = document.querySelectorAll(".chooseList_item")
            if(this.choose_animation){
                this.$refs.chooseTitle.classList.add("chooseTitleAn")
                if(items.forEach){
                    items.forEach((item) => {
                     item.style.transform = "translateY(0px)"
                     item.style.opacity = "1"
                })
                }else{
                    for(var i=0;i<items.length;i++){
                        items[i].style.transform = "translateY(0px)"
                        items[i].style.opacity = "1"
                    }
                }
            }
        }
    }
}
</script>

<style lang="stylus" scoped>
    .page-top
        border-color #f3f3f3 transparent transparent
    .chooseTitle
        transform translateY(-100px)
        opacity 0
        transition all 1s ease
    .chooseTitleAn
        transform translateY(0px)
        opacity 1
    .chooseList
        width 1200px
        margin 0 auto
    .chooseList ul
        margin 0 auto
    .chooseList ul li
        height 3.56rem
        width 24rem
        margin 0 auto
        display flex
        justify-content space-between
        transition all 1s ease-in-out
        opacity 0
    .chooseList ul li span
        display block
        width 22%
        height 100%
        background-repeat no-repeat
        background-position center
    .chooseList ul li.icon_time span.icon_time_normal
        background-image url("~@/assets/img/index_img/4_icon_time_normal.png")
    .chooseList ul li.icon_networkspeed span.icon_networkspeed_normal
        background-image url("~@/assets/img/index_img/4_icon_networkspeed_normal.png")
    .chooseList ul li.icon_safety span.icon_safety_normal
        background-image url("~@/assets/img/index_img/4_icon_safety_normal.png")
    .chooseList ul li.icon_IP span.icon_IP_normal
        background-image url("~@/assets/img/index_img/4_icon_IP_normal.png")
    .chooseList ul .chooseList_item:nth-child(odd)
        background #eeeeee

        transform translateY(-100px)
    .chooseList ul .chooseList_item:nth-child(even)

        background #656968
        transform translateY(100px)
    .chooseList ul .chooseList_item:nth-child(odd) span:nth-child(1) , .chooseList ul li:nth-child(even) span:nth-child(2)
        width 48%
    .chooseList ul .chooseList_item:nth-child(even) span:nth-child(2)
        color #eeeeee
    .chooseList .chooseList_item .item_title
        padding .56rem 0rem 0 1rem
    .chooseList .chooseList_item .item_title b
        font-size 26px
        font-weight bold
    .chooseList .chooseList_item .item_title p
        font-size 16px
        padding-top 20px
        padding-right 10px
        line-height 20px
    @media screen and (max-width: 1200px)
        .chooseList
            width auto
            margin auto
            padding 0 1rem
    @media (min-width: 768px) and (max-width: 1642px)
        .chooseList ul li
            width 100%
    @media screen and (max-width: 768px)
        .chooseList
            padding 0rem
         .chooseList ul li span
            width 40%
            background-size 36% 50%
        .chooseList ul li
            width 100%
            height 2.86rem
        .chooseList .chooseList_item .item_title
            padding .26rem 0rem 0 .2rem
            line-height .42rem
        .chooseList ul li:nth-child(odd) span:nth-child(1)  span:nth-child(1), .chooseList ul li:nth-child(even) span:nth-child(2) span:nth-child(2)
            width 60%
        .chooseList .chooseList_item .item_title b
            font-size 18px
        .chooseList .chooseList_item .item_title p
            font-size 12px
            padding-top .1rem
            padding-right .1rem
         .chooseList ul .chooseList_item:nth-child(odd) span:nth-child(1) , .chooseList ul li:nth-child(even) span:nth-child(2)
             width 60%
</style>





// WEBPACK FOOTER //
// src/pages/Home/components/choose.vue